import { ArtistResaleInput, ArtworkInput, ResaleDataInput } from "@generated/graphql";

import { ImportedResaleOutput } from "@common/csvUtils/ResaleSchema";
import { YesNo } from "@common/csvUtils/enums";
import { DateFormat, formatStringToDateFormat } from "@util/index";

export const mapArtistDetails = (data: ImportedResaleOutput) => {
  const artist: ArtistResaleInput = {
    provisional_artist_country: data.country,
    provisional_artist_name: `${data.artist_given_name} ${data.artist_middle_name} ${data.artist_family_name}`,
    provisional_artist_yob: data.year_of_birth ? Number.parseInt(data.year_of_birth) : undefined,
    provisional_artist_yod: data.year_of_death ? Number.parseInt(data.year_of_death) : undefined,
    provisional_is_artist_alive: data.artist_living === YesNo.Unknown ? undefined : data.artist_living === YesNo.Yes,
  };
  return artist;
};

export const mapArtworkDetails = (data: ImportedResaleOutput) => {
  const artwork: ArtworkInput = {
    artwork_name: data.title,
    medium: data.medium,
    description: data.details,
    height: data.dimensions_height,
    width: data.dimensions_width,
    artist_work_id: data.artist_work_id,
    gallery_work_id: data.gallery_work_id,
  };
  return artwork;
};

export const mapResaleDetails = (data: ImportedResaleOutput) => {
  const resale: ResaleDataInput = {
    acquired_date_choice: data.seller_acquired_work_post_8th_june_2010,
    artwork_sale_date: formatStringToDateFormat(data.date_sold, DateFormat.YYYY_MM_DD_DASH),
    artwork_sale_price: data.sale_price,
  };
  return resale;
};
